/**
 * Matches "Add to cart" to the real height of Razorpay's Buy Now button.
 *
 * Razorpay's button sizes itself from padding inside a CLOSED shadow root, so
 * it ignores any height we set and cannot be measured directly. What we can
 * measure is .magic-buy-btn, the light-DOM wrapper around it.
 *
 * That wrapper's height depends on whether Razorpay is drawing its subtext
 * strip ("Secured by Razorpay" / "All payment modes..."):
 *
 *   - subtext ON  -> wrapper is ~96px, button plus strip. Too big to use, so
 *                    we fall back to BUTTON_HEIGHT and clip the strip off.
 *   - subtext OFF -> wrapper IS the button, so the measurement is exact.
 *
 * So this self-corrects: the day Razorpay applies showSubtext:false to the
 * account, the measured value takes over and the match becomes precise.
 */
(() => {
  /* The height we want the buttons to be. Measurement below only ever raises
     this, never lowers it, so the requested size holds. */
  const BUTTON_HEIGHT = 48;

  /* Anything taller than this is the wrapper including the subtext strip,
     not the button on its own. */
  const SUBTEXT_THRESHOLD = 60;

  const row = () => {
    const el = document.querySelector(
      '.section-main-product .product-form .quantity-submit-row.has-spb'
    );
    // The quick-buy drawer reuses this markup and is laid out differently.
    return el && !el.closest('.quickbuy-container') ? el : null;
  };

  const sync = () => {
    const el = row();
    if (!el) return;

    const wrapper = el.querySelector('.magic-buy-btn');
    // No Razorpay button on the page - leave the CSS default alone.
    if (!wrapper) return;

    const measured = wrapper.getBoundingClientRect().height;

    // Only trust the measurement when the subtext strip isn't inflating it,
    // and only ever grow past BUTTON_HEIGHT - never shrink below it - so the
    // requested height holds while Razorpay's button still can't be clipped.
    const usable =
      measured > 0 && measured <= SUBTEXT_THRESHOLD ? Math.ceil(measured) : 0;
    const height = Math.max(BUTTON_HEIGHT, usable);

    const next = `${height}px`;
    if (el.style.getPropertyValue('--buy-btn-h') !== next) {
      el.style.setProperty('--buy-btn-h', next);
    }
  };

  const start = () => {
    sync();

    // Razorpay injects its button well after load, and re-creates it on
    // variant change, so keep watching rather than measuring once.
    new MutationObserver(sync).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.addEventListener('resize', sync);

    // Fonts landing late can change the button's height.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(() => {});
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
